import { render, staticRenderFns } from "./CoinsBanner.vue?vue&type=template&id=3e1e28bc&scoped=true"
import script from "./CoinsBanner.vue?vue&type=script&lang=js"
export * from "./CoinsBanner.vue?vue&type=script&lang=js"
import style0 from "./CoinsBanner.vue?vue&type=style&index=0&id=3e1e28bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1e28bc",
  null
  
)

export default component.exports